import { render, staticRenderFns } from "./travelAgencyHome.vue?vue&type=template&id=14ef73f6&scoped=true"
import script from "./travelAgencyHome.vue?vue&type=script&lang=js"
export * from "./travelAgencyHome.vue?vue&type=script&lang=js"
import style0 from "./travelAgencyHome.vue?vue&type=style&index=0&id=14ef73f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef73f6",
  null
  
)

export default component.exports